var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.11196 20.6567C8.34067 20.8892 8.65515 21.0054 8.96961 21.0054C9.28408 21.0054 9.59856 20.8892 9.82727 20.6567L23.6355 6.82918C24.1215 6.36439 24.1215 5.58005 23.6355 5.08621L21.9201 3.34324C21.4341 2.87845 20.6622 2.87845 20.2049 3.34324L8.96961 14.5854L3.79511 9.41459C3.30911 8.94979 2.53723 8.94979 2.07981 9.41459L0.364502 11.1576C-0.121501 11.6224 -0.121501 12.4067 0.364502 12.9005L8.11196 20.6567Z","fill":"currentColor"}));
}

Check.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Check;

Check.default = Check;
